module.exports = __webpack_public_path__ + "img/techManage_bg.b3e5022.png";